const sending = state => state.sending;

export default {
  sending
}
